<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row table-responsive" style="margin: 0 !important">
        <div
          class="card-wrap"
          v-for="(item, index) in schoolTypeList"
          :key="index"
        >
          <div class="card-title">{{ item.schoolName }}</div>
          <el-card
            :body-style="{ display: 'flex' }"
            shadow="hover"
          >
            <div class="card-content">
              <div class="content-wrap">
                <div class="text-wrap">
                  <div class="text-title-wrap">
                    <div class="text-title" style="text-decoration:underline;">Total No. of Entries =</div>
                    <div class="text-title">Categorized = </div>
                    <div class="text-title">Scoring Completed = </div>
                  </div>
                  <div class="text-value-wrap">
                    <div class="text-value" style="text-decoration:underline;">{{	'&nbsp'+(item.data.totalEntry||0)}}</div>
                    <div class="text-value">{{'&nbsp'+(item.data.categorized||0)}}</div>
                    <div class="text-value">{{'&nbsp'+(item.data.scoringCompleted||0)}}</div>
                  </div>
                </div>
                <div class="text-wrap">
                  <div class="text-title-wrap">
                    <div class="text-title">Pending Categorization = </div> 
                    <div class="text-title">Pending Scoring = </div>
                  </div>
                  <div class="text-value-wrap">
                    <div class="text-value">{{'&nbsp'+(item.data.pendingCategorization||0)}}</div>
                    <div class="text-value">{{'&nbsp'+(item.data.pendingScoring||0)}}</div>
                  </div>
                </div>
              </div>
              <div class="button-wrap">
                <el-button @click="navToDetail(item.navType, item.navParams)"
                  >Details</el-button
                >
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      userInfo:{userId:'',token:''},
      schoolTypeList: [
        {
          schoolName: "Junior Primary School",
          navType: "1",
          navParams: {},
          data: {},
        },
        {
          schoolName: "Senior Primary School",
          navType: "2",
          navParams: {},
          data: {},
        },
        {
          schoolName: "Junior Secondary School",
          navType: "3",
          navParams: {},
          data: {},
        },
        {
          schoolName: "Senior Secondary School",
          navType: "4",
          navParams: {},
          data: {},
        },
      ],
    };
  },

  created() {
    this.getUserInfo()
    this.intiPage()
  },
  mounted() {},
  components: {},
  computed: {
    baseURL() {
      return config.domain + "/";
    },
  },
  methods: {
    getUserInfo(){
      this.userInfo=this.getAuthObj();
    },
    async intiPage(){
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getJudgeOverall', {...this.userInfo})
      if(status_code=='0') {
        if(result && result.length){
          result.forEach(i => {
            this.schoolTypeList[Number(i.level)-1].data=i
          });
        }
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    navToDetail(navType, params) {
      this.$router.push({
        path: "/main/overallStatusDetail",
        query: {
          navType,
          ...params
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-wrap {
  margin-bottom: 30px;
  .card-title {
    font-size: 18px;
    font-weight: 600;
  }
}
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .content-wrap {
    display: flex;
    .text-wrap {
      display: flex;
      margin-right: 60px;
      align-items: flex-end;
      .text-title-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .text-title{
          padding:5px 0;
        }
      }
      .text-value-wrap{
        .text-value{
          padding:5px 0;
        }
      }
    }
  }
}
</style>
